<template>
  <div class="order-item__detail">
    <div class="order-item__detail-card" style="height: 300px;">
      <MapContainer ref="mapRef" mapLayer="normal" :showBottom="false" :showZoomTool="false" :showSearch="false">
        <template slot="openlayer">
          <LVector ref="olVector" zIndex="50">
            <LPointFeature v-if="currentPosition.length > 0" ref="olPointFeature" :longitude="currentPosition[0]"
              :latitude="currentPosition[1]" :defaultStyle="markerStyle" />
            <LLineFeature ref="traceLineRef" v-if="routePoints.length > 0" :pointData="routePoints"
              :defaultStyle="{ stroke: { color: '#2e7df8', width: 6, lineCap: 'butt' } }" />
            <LPointFeature v-for="item in siteList" :key="item.id" :longitude="item.longitude" :latitude="item.latitude"
              :id="item.id" :defaultStyle="getMarkerStyle(item)">
            </LPointFeature>
          </LVector>
        </template>
      </MapContainer>
    </div>
    <div class="order-item__detail-card">
      <div></div>
      <el-form class="order-item__form">
        <el-form-item label="配送单编号：">
          <div>{{ orderData.code }}</div>
        </el-form-item>
        <el-form-item label="配送路线：">
          <div>{{ orderData.startSiteName }} - {{ orderData.endSiteName }}</div>
        </el-form-item>
        <el-form-item label="配送内容：">
          <div style="position: relative;">
            <span> {{ orderData.content }}</span>

            <span style="cursor: pointer;position: absolute;right: 0;" @click="isExpand = !isExpand">
              {{ isExpand ? '收起' : '展开' }}
              <i :class="{ 'el-icon-arrow-down': !isExpand, 'el-icon-arrow-up': isExpand }"></i>
            </span>
          </div>
          <transition name="expand">
            <div v-if="isExpand">
              <OrderItem class="takeout-order-item" v-for="item in orderData.itemList" :key="item.id" :data="item"
                :showFooter="false" :showStatus="false" />
            </div>
          </transition>
        </el-form-item>


      </el-form>
    </div>
    <div class="order-item__detail-card" v-if="logList.length > 0">
      <el-timeline>
        <el-timeline-item v-for="(activity, index) in logList" :key="index" :timestamp="activity.createTime"
          hide-timestamp placement="top" :type="activity.type" :icon="activity.icon" :color="activity.color">

          <div class="timeline-item__content">
            <div>
              <span class="timeline-item__title"> {{ activity.action }}</span>
              <!-- <span class="timeline-item__timestamp"> {{ activity.createTime }}</span> -->
            </div>
            <div>{{ activity.comment }}</div>
            <div>
              <!-- <span class="timeline-item__label">【操作人】</span> -->
              <span class="timeline-item__operatorName"> {{ activity.operatorName }}</span>
              <span class="timeline-item__timestamp"> {{ activity.createTime }}</span>
            </div>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
/**
 * 配送单详情
 */
import OrderApi from '@/page/business/wuliu/api/order';
import OrderTaskApi from '@/page/business/wuliu/api/OrderTask';
import MapContainer from '@/components/map/MapContainer/MapContainer.vue';
import { LVector, LPointFeature, LLineFeature } from '@OpenLayersCommon';
import OrderItem from './OrderItem/OrderItem.vue'
export default {
  name: 'DeliveryOrderDetail',
  components: {
    MapContainer,
    LVector,
    LPointFeature,
    LLineFeature,
    OrderItem
  },
  created() {
    this.getDetail();
    this.getLog();
  },
  props: {
    // 配送单id
    id: {
      type: [Number, String],
      default: ''
    }
  },

  data() {
    return {
      orderData: {},
      logList: [],//配送订单日志列表
      loationTimer: null,//实时位置信息定时器
      orderStatus: 0,//配送订单状态
      // currentPosition: [113.19943732, 23.0450611237],//当前位置信息
      currentPosition: [],//当前位置信息
      tracePoints: [],//配送单轨迹信息
      siteList: [],//配送站列表
      isExpand: false,
    };
  },
  computed: {
    markerStyle() {
      return {
        icon: {
          src: require('@/page/mainPage/mapComponents/imgs/aircraft.png'),

        },
      }
    },
    /**
     * 配送单轨迹点信息，用于地图展示轨迹线
     */
    routePoints() {
      let list = []
      if (this.tracePoints.length > 0) {
        list = this.tracePoints.map((item) => [Number(item.longitude), Number(item.latitude)]);
      }
      return list;
    }
  },
  methods: {
    getMarkerStyle(data) {
      const { type } = data || {};
      let src = require('@/assets/images/wuliu/chuku.png');
      let name = data.name || '';
      if (type == 'T') {
        // 收货站
        src = require('@/assets/images/wuliu/shouhuo.png');

        name += '(收货站)';
      } else {
        name += '(配送站)';
      }
      let result = {
        icon: {
          src,
          // width: 10,
          // height: 10,
          scale: 0.8,
        },
        text: {
          text: name,
          font: '12px sans-serif',
          offsetY: 20,
          stroke: {
            color: '#ffffff',
            width: 2,
          },

        },
      };
      return result;
    },
    // 获取配送单详情
    getDetail() {
      if (!this.id) {
        return;
      }
      this.siteList = [];
      OrderApi.fetchDeliveryOrderInfo(this.id).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.orderData = res.data || {};
          const { status, startSiteName, startSiteLocation, endSiteName, endSiteLocation } = this.orderData;
          let orderStatus = Number(status);
          this.orderStatus = orderStatus;
          // 定时获取实时位置信息
          this.timerGetLocationInfo();
          this.getTrace();
          if (startSiteName && startSiteLocation) {
            this.siteList.push({
              name: startSiteName,
              longitude: startSiteLocation[0],
              latitude: startSiteLocation[1],
              type: "D"
            })
          }
          if (endSiteName && endSiteLocation) {
            this.siteList.push({
              name: endSiteName,
              longitude: endSiteLocation[0],
              latitude: endSiteLocation[1],
              type: "T"
            })
          }

        }
      })
    },
    // 获取配送单日志
    getLog() {
      if (!this.id) {
        return;
      }
      OrderApi.fetchDeliveryOrderLog(this.id).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.logList = res.data || {};

          if (this.logList.length > 0) {

            this.logList.forEach((item, index) => {
              if (index == 0) {
                item.type = 'primary';
                item.icon = "el-icon-check"
                item.color = '#5bf0fc'
              } else {
                item.type = '';


              }
            })

          }


        }
      })
    },
    timerGetLocationInfo() {
      const self = this
      // 先清除之前的定时器
      clearInterval(this.loationTimer);
      const orderStatus = this.orderStatus;
      if ((orderStatus >= 2 && orderStatus <= 5)) {
        //status [2-5]配送中、已到达、待返航、返航中,在这些状态下，才查询实时位置信息
        this.getLoationInfo();
        // 定时器，每5秒查询一次实时位置信息
        this.loationTimer = setInterval(() => {
          if ((orderStatus >= 2 && orderStatus <= 5)) {
            self.getLoationInfo();
            self.getTrace();
          } else {
            clearInterval(self.loationTimer);
          }

        }, 5000);
      }


    },
    // 获取配送单实时位置信息
    getLoationInfo() {
      OrderApi.fetchDeliveryOrderStatus(this.id).then((res) => {

        if (res.code == 200) {
          let { status, longitude, latitude } = res.data || {};
          let orderStatus = status ? Number(status) : 0;
          this.orderStatus = orderStatus;
          if (longitude && latitude) {
            // 绘制配送单实时位置信息
            this.currentPosition = [Number(longitude), Number(latitude)];
          } else {
            this.currentPosition = [];
          }
        }
      })
    },
    getTrace() {
      if (!this.id) {
        return;
      }
      OrderTaskApi.fetchTaskOrderTrace(this.id).then((res) => {

        if (res.code == 200) {
          this.tracePoints = res.data || []

        }
      })
    }
  },
  mounted() {
    this.getDetail();
    this.getLog();
    this.$nextTick(() => {
      if (this.currentPosition.length > 0) {
        if (this.$refs.mapRef) {
          setTimeout(() => {
            this.$refs.mapRef.toCenter(this.currentPosition);
          }, 1000);


        }

      }
    });
  },
  beforeDestroy() {
    clearInterval(this.loationTimer);
  },
  watch: {
    id(newVal, oldVal) {
      if (newVal) {
        this.getDetail();
      }
    },
    currentPosition(newVal, oldVal) {
      if (newVal.length > 0) {
        if (this.$refs.mapRef) {
          this.$refs.mapRef.toCenter(newVal);
        }

      }
    },
    tracePoints(newVal, oldVal) {
      this.$nextTick(() => {
        if (this.currentPosition.length <= 0) {
          if (this.$refs.mapRef) {
            if (this.$refs.traceLineRef) {
              let feature = this.$refs.traceLineRef.$component
              if (feature) {
                const extent = feature.getGeometry().getExtent();
                this.$refs.mapRef.fitExtent(extent, { padding: [20, 20, 20, 20] });
              }

            }
          }
        }
      })

    }

  }
};
</script>


<style lang="scss" scoped>
$bgColor: #0D1541;
$bgColor2: #0D134F;
$colorLight: #5bf0fc;
$borderColor: #2e355b;
$hoverBgColor: rgba(91, 240, 252, 0.1);

.order-item__detail {
  .order-item__detail-card {
    padding: 10px;
    background-color: $hoverBgColor;
    border-radius: 4px;
    margin-bottom: 10px;
  }

  .order-item__form {
    .el-form-item {
      margin-bottom: 6px;
    }
  }

  .takeout-order-item {
    border-bottom: 1px solid #1E76ED;
    ;
  }

  .timeline-item {
    &__content {
      line-height: 1.5;
    }

    &__title {
      font-size: 16px;
      font-weight: bold;
      color: $colorLight
    }

    &__operatorName {
      color: rgba(255, 255, 255, 0.7);
      font-size: 12px;
    }

    &__timestamp {
      color: rgba(255, 255, 255, 0.7);
      line-height: 1;
      font-size: 12px;
    }

  }

  .expand-enter-active {
    animation: expand-in .5s;
  }

  .expand-leave-active {
    animation: expand-in .5s reverse;
  }

  @keyframes expand-in {
    0% {
      height: 0px;
      overflow: hidden;
    }

    100% {
      height: auto;
    }
  }
}
</style>